import { render, staticRenderFns } from "./copyCenterList.vue?vue&type=template&id=119362ee&scoped=true&"
import script from "./copyCenterList.vue?vue&type=script&lang=js&"
export * from "./copyCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119362ee",
  null
  
)

export default component.exports